import { Box, Divider, Paper, useTheme } from "@mui/material";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../hooks/useAuth";
import ButtonCreateTransaction from "../features/Wallets/ButtonCreateTransaction";
import MainAppBar from "../global/MainAppBar/MainAppBar";
import Navigation from "../global/Navigation/Navigation";
import Logo from "../ui/Logo";
import UserMenu from "../ui/UserMenu/UserMenu";
import SharedLayout from "./SharedLayout";

const DesktopLayout = ({ hideAppbar = false, children }: { hideAppbar?: boolean, children: ReactNode }) => {
  const theme = useTheme();
  const { user } = useAuth();
  const { t } = useTranslation('common');

  return (
    <SharedLayout>
      <Box sx={{ display: 'flex', minHeight: 'var(--screen-height)', overflow: 'hidden' }}>
        {/* Sidebar */}
        {user && <Paper
          elevation={3}
          sx={{
            width: theme.mixins.sidebar.width,
            borderRadius: 0,
            display: 'flex',
            flexDirection: 'column',
            height: 'var(--screen-height)',
            color: theme.palette.common.white,
            position: 'fixed',
            backgroundColor: theme.palette.navy[900],
            zIndex: theme.zIndex.drawer + 1
          }}
        >
          <Box py={2} px={3}>
            <Logo iconOnly aria-label={t('app_logo')} />
          </Box>

          <Divider />

          {/* Navigation */}
          <Navigation />

          {/* User - positioned at the bottom of sidebar */}
          <Box sx={{ mt: 'auto' }}>
            <UserMenu user={user} />
          </Box>
        </Paper>}

        {/* Main content */}
        <Box sx={{
          flex: 1,
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
          marginLeft: user ? `${theme.mixins.sidebar.width}px` : 0,
          width: user ? `calc(100% - ${theme.mixins.sidebar.width}px)` : '100%',
        }}>
          {!hideAppbar && <MainAppBar />}

          {children}

          <ButtonCreateTransaction />
        </Box>
      </Box>
    </SharedLayout>
  );
};

export default DesktopLayout; 